import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiHelper } from '@helpers/ui.helper';

export interface DialogData {
  barcode: string;
  type: string;
}

@Component({
  selector: 'barcode-dialog',
  templateUrl: '../sharedTemplates/barcode.dialog.component.html',
})
export class BarcodeDialog {
  format = 'CODE128';
  lineColor = '#000000';
  width = 4;
  height = 150;
  displayValue = true;
  fontOptions = '';
  font = 'monospace';
  textAlign = 'center';
  textPosition = 'bottom';
  textMargin = 10;
  fontSize = 22;
  background = '#ffffff';
  margin = 5;
  marginTop = 5;
  marginBottom = 5;
  marginLeft = 5;
  marginRight = 5;

  constructor(public dialogRef: MatDialogRef<BarcodeDialog>, private _UiHelper: UiHelper, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this._UiHelper.closeAllMenus();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
